import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Repo from "../../Repository/Repo";

const initialState = {
  loading: false,
  error: "",
  details: [],
};

export const fastCashDetails = createAsyncThunk(
  "fastCashDetails/fetchfastCashDetails",
  (data) => {
    return Repo.fastcash({
      request: {
        method: "getFastCashEntries",
        data: {
          _id: data._id,
          date: data.date,
        },
      },
    })
      .then(({ data }) => data.response.data.fast_cash_entries)
      .catch((err) => console.log(err));
  }
);

export const detailsSlice = createSlice({
  name: "fastCashDetails",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(fastCashDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fastCashDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.details = action.payload;
      state.error = "";
    });
    builder.addCase(fastCashDetails.rejected, (state, action) => {
      state.loading = false;
      state.details = [];
      state.error = action.error.message;
    });
  },
});

export default detailsSlice.reducer;
